/**
 * Public routes that don't require authentication
 * Type-safe using TanStack Router's generated types
 */

import type { RegisteredRouter } from '@tanstack/react-router';

export const PUBLIC_PATHS = [
  '/login',
  '/register',
  '/forgot-password',
] as const satisfies readonly RegisteredRouter['routesByPath'][keyof RegisteredRouter['routesByPath']]['fullPath'][];
